import React from 'react';
import brandName from '../../../images/brandName.png';

const HomeBanner = () => {
  return (
    <div className='HomeBanner'>
      <div>
        <div>
          <img src={brandName} alt='' />
        </div>
        <div>
          <i className='fa fa-play' aria-hidden='true'></i>
        </div>
      </div>
    </div>
  );
};
export default HomeBanner;
